import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '../features/auth/requireAuth';
import { RemindPasswordPage } from '../pages/remindPasswordPage';
import { LayoutAfterLoginApp } from '../widgets/layoutAfterLoginApp';
import AfterLoginApp from './AfterLoginApp';

// подключение иконок prime react
import 'primeicons/primeicons.css';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
// подключение главного файла стилей scss
import '../styles/main.scss';
import { ResetPasswordPage } from '../pages/resetPasswordPage';
import { ConfirmRegisterPage } from '../pages/confirmRegisterPage';
import LoginPage from '../pages/loginPage/LoginPage';
import { RegisterPage } from '../pages/registerPage';


// Входной компонент, отвечающий за переадресацию после успешной авторизации
function App() {
    return (
        <div className="app">
            <Routes>
                <Route path='/login' element={<LoginPage />} />
                <Route path='/login/:databasePrefix' element={<LoginPage />} />
                <Route path='/' element={<RequireAuth />}>
                    <Route path="/" element={<LayoutAfterLoginApp />}>
                        <Route path="/" element={<Navigate to="/app/roads/list" />} />
                        <Route path="/app" element={<Navigate to="roads/list" />} />
                        <Route path="/app/*" element={<AfterLoginApp />} />
                    </Route>
                </Route>
                <Route path="/remind" element={<RemindPasswordPage />} />
                <Route path="/reset/:dataBase/:guid" element={<ResetPasswordPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/confirm/:dataBase/:guid" element={<ConfirmRegisterPage />} />
            </Routes>
        </div>
    );
}

export default App;
